import { render, staticRenderFns } from "./view_services.vue?vue&type=template&id=342042b1"
import script from "./view_services.vue?vue&type=script&lang=js"
export * from "./view_services.vue?vue&type=script&lang=js"
import style0 from "./view_services.vue?vue&type=style&index=0&id=342042b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports